var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-layout',{staticClass:"input-radio",attrs:{"for":_vm.inputId,"gap":"3","align":"center","tag":"label"}},[_c('span',{class:{
            'input-radio__input': true,
            'input-radio__input--checked': _vm.checked,
            'input-radio__input--disabled': _vm.disabled,
            'input-radio__input--error': _vm.state === 'error',
        }},[_c('input',{attrs:{"id":_vm.inputId,"type":"radio","name":_vm.name,"disabled":_vm.disabled,"aria-describedby":_vm.ariaDescribedby},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.handleChange}})]),_vm._v(" "),_c('span',{staticClass:"input-radio__label"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }